import {AppContext} from "../../../lib/AppContext";
import React, {useContext, useState} from "react";
import {handleDefaultValues} from "../../common/Utils";
import {useForm} from 'react-hook-form';
import {
  deleteBillingItem, getCartFull,
} from "../../common/api/PortalCustomerApi";
import {Card, CardContent, Chip, Divider, Grid} from "@mui/material";
import MDBox from "../../../components/MDBox";
import MDButton from "../../../components/MDButton";
import {CartContext} from "../../../lib/CartProvider";
import Confirm from "../../common/Confirm";
import SquareCheckoutPage from "../../../SquareCheckoutPage";
import {CONSTANTS} from "../../common/constants";
import StripeCheckoutPage from "../../../StripeCheckoutPage";
import MDTypography from "../../../components/MDTypography";
import {UserContext} from "../../../lib/UserProvider";

export default function CustomerBillingMethodsPane({customer, handleSave}) {
  const [context, setContext] = useContext(AppContext);
  const [cartContext, setCartContext] = useState(CartContext);
  const [userContext, setUserContext] = useState(UserContext);

  const [client, setClient] = useState({...customer});


  const [inventoryType, setInventoryType] = useState();
  const [formInvalid, setFormInvalid] = useState(false);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(inventoryType)
  });

  const [saving, setSaving] = useState(false);
  const [manageCard, setManageCard] = useState(false);

  const [confirmDelete, setConfirmDelete] = useState(false);
  const [confirmation, setConfirmation] = useState();
  const [error, setError] = useState(false);

  const handleEventCancel = (item) => {
    setSaving(true);
    deleteBillingItem(item).then((resp) => {
      setConfirmDelete(false);
      handleSave('reload')
    })
  }

  const handleCartSuccess = (e) => {
    setManageCard(false);
    let _context = {...context};
    _context.toast = {
      message: 'Card saved successfully',
      type: 'success'
    }
    setContext({..._context});
    handleSave('reload')
  }

  const [cart, setCart] = useState();

  return (
    <div>
      <MDBox>
        <Grid container direction="row">
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <MDTypography variant="h5" fontWeight="light">
                  Manage Payment Method {manageCard && <> <span className="btn-close"
                                                                style={{
                                                                  position: 'absolute',
                                                                  zIndex: 1000,
                                                                  width: '15px',
                                                                  height: '15px',
                                                                  top: '5px',
                                                                  right: '15px'
                                                                }}

                                                                onClick={() => {
                                                                  setManageCard(false);
                                                                }}></span>
                </>}
                </MDTypography>

                {!manageCard && <>
                  {customer?.clientBilling?.sort((a, b) => a.id - b.id).map((_billing, idx) => {
                    return (
                      <div  key={idx}>
                        <MDTypography variant="h6" fontWeight="light">
                          Payment Method
                        </MDTypography>
                        <MDButton size="small"
                                  style={{
                                    float: 'right'
                                  }}
                                  color="primary"
                                  onClick={(e) => {
                                    let _confirmation = {
                                      title: 'Delete Credit Card?',
                                      message: 'Delete card permanently?',
                                      entity: _billing
                                    }
                                    setConfirmDelete(true);
                                    setConfirmation(_confirmation);
                                  }}>
                          Delete
                        </MDButton>

                        <p><span className={'fa fa-' + _billing.cardType}></span>{_billing.cardType}</p>
                        **** **** **** {_billing.cardNumber} <br/>
                        {_billing.ccExpy}
                      </div>
                    )
                  })}
                  <div style={{
                    marginTop: '20px'
                  }}>
                    <MDButton size="small"
                              color="primary"
                              onClick={(e) => {
                                setManageCard(true);
                                getCartFull('BILLINGS').then(r => {
                                  setCart(r)
                                })
                              }}>
                      Manage
                    </MDButton>
                  </div>
                </>}

                {manageCard && <Grid item xs={12}>
                  {cart?.paymentGatewayId === CONSTANTS.EXT_APPLICATION.SQUARE && <>
                    <SquareCheckoutPage
                      storeCard={true}
                      handleSuccess={(e) => {
                        handleCartSuccess(e)
                      }}
                      handleError={(e) => {
                        setError(true)
                      }}
                      client={client}
                      cart={cart}/>
                  </>}

                  {cart?.paymentGatewayId === CONSTANTS.EXT_APPLICATION.STRIPE && <>
                    <StripeCheckoutPage
                      handleSuccess={(e) => {
                        handleCartSuccess(e)
                      }}
                      storeCard={true}
                      handleError={(e) => {
                        setError(true)
                      }}
                      client={client}
                      cart={cart}/>
                  </>
                  }
                </Grid>
                }
                {error && <p>An unexpected error has occurred. Please try again in a few moments.</p>}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {confirmDelete && <Confirm confirmation={confirmation}
                                 show={confirmDelete}
                                 saving={saving}
                                 handleConfirm={handleEventCancel}
                                 handleClose={() => {
                                   setConfirmDelete(false);
                                 }}/>}

    </div>
  )
}